export const convertObjToPickerMono = (obj) => {
  let objPickerKeys = {};
  if (obj !== undefined && typeof obj === 'object') {
    const objArrayKeys = Object.keys(obj);
    objPickerKeys = objArrayKeys.map((keyName) => {
      return {
        label: keyName,
        value: keyName,
      };
    });
  }
  return objPickerKeys;
};

export const convertObjToPicker = (obj) => {
  let objPickerKeys = {};
  if (obj !== undefined && typeof obj === 'object') {
    const objArrayKeys = Object.keys(obj);
    objPickerKeys = objArrayKeys.map((keyName) => {
      return {
        label: keyName,
        value: obj[keyName],
      };
    });
  }
  return objPickerKeys;
};

export const isEmptyString = (stringItem) => {
  const result = stringItem.trim().length === 0;
  return result;
};

export const stringNulleabler = (stringItem) => {
  let resultString = null;
  const isEmptyStringResult = stringItem.trim().length === 0;
  if (!isEmptyStringResult) {
    resultString = stringItem;
  } else {
    resultString = null;
  }
  return resultString;
};

export const getObjFromArrayByKey = (array, key, value) => {
  const recoveredObj = array.find((obj) => obj[key] === value);
  return recoveredObj;
};

export const checkObjFromFromArrayByKey = (array, key, value) => {
  const existObject = array.some((item) => item[`${key}`] === value);
  return existObject;
};

export function arraysContainSameValues(arr1, arr2) {
  return (
    arr1.length === arr2.length &&
    arr1
      .slice()
      .sort()
      .every((value, index) => value === arr2.slice().sort()[index])
  );
}

export const limitMaximumWords = (name, limit = 1) => {
  return name.split(' ').slice(0, limit).join(' ');
};

export const getBooleanStatusLabel = (value, trueLabel = 'Si', falseLabel = 'No') => {
  return value === true ? trueLabel : falseLabel;
};

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 B';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
}

export const formatTime = (seconds) => {
  if (!+seconds) return '0s';

  const units = [
    { label: 'd', value: 86400 },
    { label: 'h', value: 3600 },
    { label: 'min', value: 60 },
    { label: 's', value: 1 },
  ];

  const matchedUnit = units.find((unit) => seconds >= unit.value);
  if (matchedUnit) {
    const count = Math.floor(seconds / matchedUnit.value);
    return `${count}${matchedUnit.label}`;
  }

  return '0s'; // Fallback (aunque no debería llegar aquí)
};

export function objToBase64(obj) {
  const json = JSON.stringify(obj);
  const utf8 = new TextEncoder().encode(json);
  const binary = Array.from(utf8, (byteItem) => String.fromCharCode(byteItem)).join('');
  return btoa(binary);
}

export function safeJsonParse(value, defaultValue) {
  if (value == null) return defaultValue;
  if (typeof value === 'object') return value;
  if (typeof value !== 'string') return defaultValue;
  if (value.trim() === '') return defaultValue;

  try {
    return JSON.parse(value);
  } catch {
    return defaultValue;
  }
}
